import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=4ea3847c&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=4ea3847c&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ea3847c')) {
      api.createRecord('4ea3847c', component.options)
    } else {
      api.reload('4ea3847c', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=4ea3847c&", function () {
      api.rerender('4ea3847c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PoService/Main.vue"
export default component.exports